import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-waves-attach-feature',
	templateUrl:'./WavesAttachFeaturePluginCompPage.html',
	styles: [],
	styleUrls:['./WavesAttachFeaturePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WavesAttachFeaturePluginCompPage
{
	mdContent_1154 = `\`\`\`java
import com.jwebmp.plugins.waveseffect.WavesAttachFeature;
\`\`\``;
	mdContent_1155 = `\`\`\`java
ComponentHierarchyBase component
\`\`\``;
	mdContent_1156 = `\`\`\`java
var button = new WaButton&lt;&gt;("Click Me");
button.addFeature(new WavesAttachFeature(button));
\`\`\``;
}
